import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import InputFiled from "../../FormElement/InputFiled";

class AddressForm extends Component {
  render() {
    const { values, handleChange, userDetails } = this.props;
    console.log(userDetails);
    return (
      <React.Fragment>
        <div className="textRequired" style={{ paddingTop: 0 }}>
          * Required Cells
        </div>
        <Grid container spacing={8} style={{ justifyContent: "space-between" }}>
          <Grid item xs={10} sm={5}>
            <InputFiled
              value={values.firstName}
              label="First Name"
              required
              type="text"
              name="firstName"
              handleChange={handleChange("firstName")}
              validations={["required", "minSize", "maxSize"]}
            />
          </Grid>
          <Grid item xs={10} sm={5}>
            <InputFiled
              value={values.lastName}
              label="Last Name"
              required
              type="text"
              name="lastName"
              handleChange={handleChange("lastName")}
              validations={["required", "minSize", "maxSize"]}
            />
          </Grid>

          <Grid item xs={10} sm={5}>
            <InputFiled
              label="Town/City"
              value={values.town}
              required
              handleChange={handleChange("town")}
              validations={["required"]}
              //handleError={this.handleError}
              type="text"
              name="town"
            />
          </Grid>
          <Grid item xs={10} sm={5}>
            <InputFiled
              label="State"
              value={values.state}
              required
              handleChange={handleChange("state")}
              validations={["required"]}
              //handleError={this.handleError}
              type="text"
              name="state"
            />
          </Grid>
          <Grid item xs={10} sm={5}>
            <InputFiled
              label="Country"
              value={values.country}
              required
              handleChange={handleChange("country")}
              validations={["required"]}
              //handleError={this.handleError}
              disabled
              type="text"
              name="country"
            />
          </Grid>

          <Grid item xs={10} sm={5}>
            <InputFiled
              label="Zip Code"
              value={values.zipCode}
              required
              handleChange={handleChange("zipCode")}
              validations={["required"]}
              //handleError={this.handleError}
              type="text"
              name="zipCode"
            />
          </Grid>
          <Grid item xs={10} sm={5}>
            <InputFiled
              label="Street Address"
              value={values.streetAddress}
              required
              handleChange={handleChange("streetAddress")}
              validations={["required"]}
              //handleError={this.handleError}
              multiline
              rowsMax={2}
              type="text"
              name="streetAddress"
            />
          </Grid>
          <Grid item xs={10} sm={5}>
            <InputFiled
              label="Contact Number"
              required
              value={values.contactNo}
              handleChange={handleChange("contactNo")}
              validations={["required"]}
              type="text"
              name="contactNo"
            />
          </Grid>

          {/* <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox color="secondary" name="saveAddress" value="yes" />
            }
            label="Use this address for payment details"
          />
        </Grid> */}
        </Grid>
      </React.Fragment>
    );
  }
}

export default AddressForm;



// WEBPACK FOOTER //
// ./src/components/public/Checkout/AddressForm.js